import dayjs from "dayjs";
import Loading from 'quasar/src/plugins/loading/Loading.js';import Notify from 'quasar/src/plugins/notify/Notify.js';
import { FindFileItemCommand, FindFilesInfoCommand } from "src/api/Common/Commands/FindFilesInfoCommand";
import { FileCode, FileFetchKb } from "src/extensions/utils/DefineTypes";
import { FileHelper } from "src/extensions/utils/FileHelper";
import { computed, defineComponent, isReactive, reactive, ref } from "vue";
import { onBeforeRouteLeave, onBeforeRouteUpdate, useRoute, useRouter } from "vue-router";
import { api } from "~/api/Api";
import { GetFilesCommand } from "~/api/Common/Commands/GetFilesCommand";
import { FindFilesInfoResult } from "~/api/data/Common/FindFIlesInfoResult";
import BreadcrumbList from "~/components/BreadcrumbList.vue";
import { MsgBox } from "~/components/MsgBox";
import MypageBadge from "~/components/MypageBadge.vue";
import PdfViewer from "~/components/PdfViewer.vue";
import { auth } from "~/core/Auth";
import { Log } from "~/extensions/utils";
import { CookieHelper } from "~/extensions/utils/CookieHelper";
import { isNullOrUndefined, MypageMessageFormat } from "~/extensions/utils/DefineFunction";
import { HanyoKb, InformationDetailBeforeRouteKbn, InformationTarget, PageID, ResponseContent } from "~/extensions/utils/DefineTypes";
import { commonStore } from "~/store/CommonStore";
import { InformationResponseViewModel } from "./Models/InformationResponseViewModel";
import { InformationValidator } from "./Models/InformationValidator";
import { InformationViewModel } from "./Models/InformationViewModel";
import { ResponseFindConditionValidator } from "./Models/ResponseFindConditionValidator";
import { ResponseFindConditionViewModel } from "./Models/ResponseFindConditionViewModel";
const log = Log.create("InformationsEdit");
let resuponseList = false;
// テーブルカラム
const columns = [
    { name: "userCd", label: "契約者コード", align: "right", field: "userCd", sortable: false },
    { name: "userName", label: "契約者名", align: "left", field: "userName", sortable: false, headerStyle: "width: 600px; max-width: 600px;" },
    { name: "responseReason", label: "理由", align: "left", field: "responseReason", sortable: false, headerStyle: "width: 800px; max-width: 800px;" }
];
export default defineComponent({
    name: "InformationDetail",
    components: {
        MypageBadge,
        PdfViewer,
        BreadcrumbList
    },
    beforeRouteEnter(to, from, next) {
        if (isNullOrUndefined(from.query.nyukyokeiyakuNo) || from.name !== "nyukyosha-detail") {
            next();
            return;
        }
        next(vm => {
            const instance = vm;
            instance.setRouteFromQuery(from.query);
        });
    },
    setup() {
        const route = useRoute();
        const infoData = ref(new InformationViewModel());
        const infoTarget = InformationTarget;
        const isMt = auth.isMt;
        let urlParameters = Number(route.query.informationNo);
        let today = dayjs(new Date());
        let answerPossible = ref(false);
        const weightKbn = HanyoKb.InformationWeight;
        const aggerr = ResponseContent.aggerr;
        const negative = ResponseContent.negative;
        const filteringInfoData = ref([]);
        const aggerrList = computed(() => filteringInfoData.value.filter(x => x.responseContent === aggerr));
        const negativeList = computed(() => filteringInfoData.value.filter(x => x.responseContent === negative));
        const unansweredList = computed(() => filteringInfoData.value.filter(x => x.responseContent === ResponseContent.notAnswered));
        const beforeRouteKbn = Number(CookieHelper.get("informationDetailBeforeRoute"));
        const informationDetailBeforeRouteKbn = InformationDetailBeforeRouteKbn;
        const filter = reactive(new ResponseFindConditionViewModel());
        const routeFromQuery = ref(null);
        const imageUrls = ref({});
        const blobs = ref({});
        const visiblePopup = ref(false);
        const visibleFileDialog = ref(false);
        const slide = ref(0);
        const dialogSlide = ref(0);
        const router = useRouter();
        const findFilesInfoCommand = new FindFilesInfoCommand();
        const getFilesCommand = new GetFilesCommand();
        const result = ref(new FindFilesInfoResult());
        const zipFile = ref(null);
        const fileList = ref([]);
        const pdfFiles = computed(() => fileList.value.filter(x => FileHelper.isPDF(x.fileName)));
        const pageName = commonStore.pageName(PageID.informationDetail);
        let valid = ref(new InformationValidator(infoData.value.firstResponse));
        let responseValid = reactive(new ResponseFindConditionValidator(filter));
        // 入居者情報詳細画面に遷移したときにURLにパラメーターを追加
        onBeforeRouteLeave(to => {
            const no = routeFromQuery.value;
            if (to.name === "nyukyosha-detail" && isMt && no != null && to.query.nyukyokeiyakuNo !== String(no)) {
                return {
                    name: "nyukyosha-detail",
                    query: {
                        ...to.query,
                        nyukyokeiyakuNo: String(no)
                    }
                };
            }
        });
        const initView = async () => {
            try {
                Loading.show();
                let informationsData = await api.information.get(urlParameters);
                infoData.value = new InformationViewModel(informationsData);
                if (infoData.value.files.length > 0) {
                    await fetchFileList();
                    if (fileList.value.length === 0) {
                        router.back();
                        return;
                    }
                    slide.value = fileList.value.find(x => FileHelper.isPDF(x.fileName))?.fileId ?? 0;
                }
                if (infoData.value.isResponseRequired) {
                    if (auth.isMt) {
                        answerPossible.value = false;
                    }
                    else {
                        answerPossible.value =
                            infoData.value.responseDeadline === "" ||
                                infoData.value.response.length === 0 ||
                                today.isBefore(new Date(infoData.value.responseDeadline), "days") ||
                                today.isSame(new Date(infoData.value.responseDeadline), "days");
                        //未回答の場合、回答用のモデルを生成
                        if (infoData.value.response.length === 0) {
                            infoData.value.response.push(new InformationResponseViewModel());
                        }
                    }
                    // valid = reactive(new InformationValidator(infoData.value.firstResponse));
                    valid.value = new InformationValidator(infoData.value.firstResponse);
                    filteringInfoData.value = infoData.value.response;
                }
            }
            catch (ex) {
                log.error("get", ex);
                if (ex.data.status !== 404) {
                    await MsgBox.error(ex.data.errorMessage);
                }
            }
            finally {
                Loading.hide();
            }
        };
        const setRouteFromQuery = (query) => {
            routeFromQuery.value = query.nyukyokeiyakuNo;
        };
        const filteringData = () => {
            if (responseValid.error) {
                return;
            }
            let retRows = infoData.value.response;
            if (!isNullOrUndefined(filter.userName) && filter.userName !== "") {
                retRows = retRows.filter(row => row.userName.startsWith(filter.userName));
            }
            if (!isNullOrUndefined(filter.responseReason) && filter.responseReason !== "") {
                retRows = retRows.filter(row => row.responseReason.startsWith(filter.responseReason));
            }
            filteringInfoData.value = retRows;
        };
        const onSelectResponse = (selected) => {
            infoData.value.response[0].responseContent = selected;
        };
        const onClick = async () => {
            if (valid.value.error || infoData.value.firstResponse.responseContent === ResponseContent.notAnswered) {
                return;
            }
            const isAnswer = await MsgBox.confirm(MypageMessageFormat(commonStore.messages.PI0007, {
                val: infoData.value.firstResponse.responseContent === ResponseContent.aggerr ? infoData.value.affirmativeText : infoData.value.negativeText
            }));
            if (isAnswer) {
                try {
                    Loading.show();
                    await api.information.update(infoData.value);
                    Notify.create({ color: "green", position: "top", message: commonStore.messages.PI0008 });
                }
                catch (ex) {
                    await MsgBox.error(ex.data.errorMessage);
                    log.error("update", ex);
                }
                finally {
                    Loading.hide();
                }
            }
        };
        const fetchFileList = async () => {
            try {
                findFilesInfoCommand.informationNo = infoData.value.informationNo;
                findFilesInfoCommand.fileList = [new FindFileItemCommand(FileFetchKb.Storage, FileCode.InformationFile)];
                result.value = await api.common.findFilesInfo(findFilesInfoCommand);
                getFilesCommand.informationNo = infoData.value.informationNo;
                getFilesCommand.fileList = result.value.fileList.map(item => {
                    return {
                        fileNo: item.fileNo,
                        fileId: item.fileId,
                        fileFetchKb: FileFetchKb.Storage,
                        fileCode: item.fileCode,
                        fileExists: item.fileExists
                    };
                });
                const res = await api.common.getFiles(getFilesCommand);
                zipFile.value = res;
                // Zip内からファイル取得
                fileList.value = await FileHelper.getFilesFromZip(zipFile.value, result.value.fileList);
                // ファイル表示用データ設定
                fileList.value.forEach(file => {
                    if (!file.blob) {
                        return;
                    }
                    const imageUrl = FileHelper.createObjectUrl(file.blob);
                    if (!FileHelper.isPDF(file.fileName ?? "")) {
                        imageUrls.value[file.fileId] = imageUrl;
                    }
                    blobs.value[file.fileId] = file.blob;
                });
            }
            catch (ex) {
                log.error("checkPropertyFile", ex);
                MsgBox.error(ex.message);
            }
        };
        const openPreview = (index) => {
            dialogSlide.value = index;
            visibleFileDialog.value = true;
        };
        const DownLoadFile = (fileId) => {
            const blob = blobs.value[fileId];
            if (!blob) {
                return;
            }
            const fileName = fileList.value.find(x => x.fileId === fileId)?.fileName.replace(/^\d+_/, "") ?? "file";
            FileHelper.downloadBlob(blob, fileName);
        };
        const selectSlide = (fileId) => {
            slide.value = fileId;
        };
        onBeforeRouteUpdate(async (to, from) => {
            if (to.query.informationNo !== from.query.informationNo) {
                urlParameters = Number(to.query.informationNo);
                try {
                    let informationsData = await api.information.get(urlParameters);
                    infoData.value = new InformationViewModel(informationsData);
                    if (infoData.value.files.length > 0) {
                        try {
                            Loading.show();
                            await fetchFileList();
                            if (fileList.value.length === 0) {
                                router.back();
                                return;
                            }
                        }
                        finally {
                            Loading.hide();
                        }
                        slide.value = fileList.value.find(x => FileHelper.isPDF(x.fileName))?.fileId ?? 0;
                    }
                    if (infoData.value.isResponseRequired) {
                        if (auth.isMt) {
                            answerPossible.value = false;
                        }
                        else {
                            answerPossible.value =
                                infoData.value.responseDeadline === "" ||
                                    infoData.value.response.length === 0 ||
                                    today.isBefore(new Date(infoData.value.responseDeadline), "days") ||
                                    today.isSame(new Date(infoData.value.responseDeadline), "days");
                            if (infoData.value.response.length === 0) {
                                infoData.value.response.push(new InformationResponseViewModel());
                            }
                        }
                        valid.value = new InformationValidator(infoData.value.firstResponse);
                        filteringInfoData.value = infoData.value.response;
                    }
                }
                catch (ex) {
                    await MsgBox.error(ex.data.errorMessage);
                    log.error("get", ex);
                }
            }
        });
        initView();
        return {
            pageName,
            PageID,
            columns,
            filter,
            filteringInfoData,
            infoTarget,
            tab: ref("aggerr"),
            infoData,
            aggerrList,
            negativeList,
            unansweredList,
            resuponseList,
            weightKbn,
            aggerr,
            negative,
            answerPossible,
            valid,
            beforeRouteKbn,
            informationDetailBeforeRouteKbn,
            responseValid,
            routeFromQuery,
            imageUrls,
            visiblePopup,
            isMt,
            visibleFileDialog,
            slide,
            blobs,
            dialogSlide,
            fileList,
            pdfFiles,
            FileHelper,
            filteringData,
            isReactive,
            onSelectResponse,
            onClick,
            isNullOrUndefined,
            setRouteFromQuery,
            openPreview,
            DownLoadFile,
            selectSlide
        };
    }
});
